import {defineStore} from 'pinia'
import {useUserStore} from "./user";
import {normalizeObjectUrls} from '@/utils/httpUrl'

export const useLocalizedObjectStore = defineStore('localizedObject', {
    // a function that returns a fresh state
    state: () => ({
    }),
    // optional getters
    getters: {},
    // optional actions
    actions: {
        apiShow(id, lang) {
            return this.apiClientV2.get(`/objects/${id}/${lang}`)
        },
        apiCreate(object) {
            const kdnr = useUserStore().user.organisation.kdnr;
            // Yup transforms are validated by vee-validate but may not reach submit handlers.
            return this.apiClientV2.post(`/objects`, {kdnr, object: normalizeObjectUrls(object)})
        },
        apiUpdate(object) {
            const kdnr = useUserStore().user.organisation.kdnr;
            return this.apiClientV2.patch(`/objects/${object.id}/${object.lang}`, {kdnr, object: normalizeObjectUrls(object)})
        },
    },
})
